export const msalConfigProd = {
    auth: {
      clientId: "ebb5ebdb-49e8-4ac3-b7ef-343b351ca7a5",
      authority: "https://login.microsoftonline.com/common", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      redirectUri: "http://localhost:3000",
      postLogoutRedirectUri: window.location.origin,
      redirectUri: window.location.origin,
      navigateToLoginRequestUrl: true
      //add https://compassapi.azurewebsites.net/fulfillment/ when in visual studio api
    },
    cache: {
      cacheLocation: "localStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequestProd = {
   scopes: ["api://e6ad8039-1367-4ccb-afbd-ad665560bbf7/useraccess"]
  };

  export const msalConfigDev = {
    auth: {
      clientId: "ebb5ebdb-49e8-4ac3-b7ef-343b351ca7a5",
      authority: "https://login.microsoftonline.com/common", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      redirectUri: "http://localhost:3000",
      postLogoutRedirectUri: window.location.origin,
      redirectUri: window.location.origin,
      navigateToLoginRequestUrl: true
      //add https://compassapi.azurewebsites.net/fulfillment/ when in visual studio api
    },
    cache: {
      cacheLocation: "localStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };
  
  // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
  export const loginRequestDev = {
   scopes: ["api://e6ad8039-1367-4ccb-afbd-ad665560bbf7/useraccess"]
  };
  
  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  export const graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/beta/me"
  };

  
